export default __webpack_public_path__ + "static/media/AndriyK352.0d31f6dc.jpg";